import type { RenderContext, VideoFrame } from '../../types';
import { BaseEffect } from '../base';
import { effectSeed, withOverlay } from './composite';
import { fbmNoise2D } from '../../utils/noise';

const DEFAULTS = { coverage: 0.7, speed: 0.2 };

export class CinematicCloudsEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'cinematic_clouds', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    return this.renderCpu(frame, params, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const seed = effectSeed(context, this.id);
    const t = context.frameIndex * params.speed * 0.015;
    return withOverlay(frame, (ctx, w, h) => {
      const skyH = h * 0.45;
      for (let y = 0; y < skyH; y += 1) {
        for (let x = 0; x < w; x += 2) {
          const n1 = fbmNoise2D(x * 0.003 + t, y * 0.004, seed, 4);
          const n2 = fbmNoise2D(x * 0.006 + t * 1.3, y * 0.005, seed + 50, 3);
          const cloud = Math.max(0, (n1 * 0.6 + n2 * 0.4 - (1 - params.coverage)) * 1.5);
          if (cloud > 0.02) {
            ctx.fillStyle = `rgba(255,255,255,${cloud * 0.25})`;
            ctx.fillRect(x, y, 2, 1);
          }
        }
      }
    }, 'source-over');
  }
}
